import React from 'react';
import './assets/css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './util/UserUtils';
import {createRoot} from 'react-dom/client'

const rootElement = document.getElementById('root')
const reactRoot = createRoot(rootElement)

reactRoot.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
